import { render, staticRenderFns } from "./AsetModal.vue?vue&type=template&id=2b84d50b&"
import script from "./AsetModal.vue?vue&type=script&lang=js&"
export * from "./AsetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports